import { render, staticRenderFns } from "./KPIsDialog.vue?vue&type=template&id=16a8899c&scoped=true&"
import script from "./KPIsDialog.vue?vue&type=script&lang=js&"
export * from "./KPIsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8899c",
  null
  
)

export default component.exports